const ComboListCtrl = function (productService, isMobileService, comboStateService) {
  const ctrl = this;
  const isMobile = isMobileService.getValue();
  ctrl.$onInit = function () {
    ctrl.comboList = comboStateService.comboList;
    if (ctrl.currencySymbol) {
      comboStateService.currencySymbol = ctrl.currencySymbol;
    }
  };
  ctrl.getComboList = function (productId) {
    comboStateService.comboItemsArr = [];
    productService.getComboList(productId).then(function (result) {
      if (result) {
        comboStateService.setComboList(result.data.obj);
        ctrl.comboList = comboStateService.comboList;
        if (ctrl.onInit) {
          ctrl.onInit({
            combo: ctrl
          });
        }
      }
    });
  };
  ctrl.editComboPositionMode = function (event, comboItem, index) {
    if (comboStateService.getEditModeComboPosition() && comboStateService.getActiveEditCombo().Id === comboItem.Id) {
      if (isMobile) {
        return;
      }
      if (comboStateService.getIsEditOtionsMode()) {
        comboStateService.exitOptionsMode();
        return;
      } else {
        comboStateService.exitPositionMode();
        return;
      }
    }
    comboStateService.setActiveCombo(index, comboStateService.comboList.find(function (combo) {
      return combo.Id === comboItem.Id;
    }));
    if (event.target.className === 'combo-item__edit-options') {
      ctrl.setEditPositionOptions();
    } else {
      ctrl.exitOptionsMode();
    }
  };
  ctrl.setEditPositionOptions = function () {
    comboStateService.enterOptionsMode();
  };
  ctrl.exitOptionsMode = function () {
    comboStateService.exitOptionsMode();
  };
  ctrl.getActiveEditCombo = function () {
    return comboStateService.getActiveEditCombo();
  };
  ctrl.getComboItemsArr = function () {
    return comboStateService.getComboItemsArr();
  };
  ctrl.getEditModeComboPosition = function () {
    return comboStateService.getEditModeComboPosition();
  };
  ctrl.getActiveComboIndex = function () {
    return comboStateService.getActiveComboIndex();
  };
  ctrl.getIsEditOtionsMode = function () {
    return comboStateService.getIsEditOtionsMode();
  };
  ctrl.getComboDiscountPrice = function () {
    return comboStateService.getComboDiscountPrice();
  };
  ctrl.getComboBasePrice = function () {
    return comboStateService.getComboBasePrice();
  };
  ctrl.getComboWithDiscount = function () {
    return comboStateService.getComboWithDiscount();
  };
};
ComboListCtrl.$inject = ["productService", "isMobileService", "comboStateService"];
export default ComboListCtrl;